import { api } from '@creditsights/api-ui-web';
import { TopReadsRange } from '../../models';
import { ArticleListDto } from '../dtos/article/articleList.dto';
import { TagsFilterParams } from '../tags/tags.model';

const moduleUri = '/common/v1/feeds/top_read';

export const fetchTopReads = async (
  range: TopReadsRange,
  myCS: boolean,
  tags: TagsFilterParams,
  textContains?: string,
  startDate?: Date,
  endDate?: Date
): Promise<ArticleListDto> => {
  const { data } = await api.post<ArticleListDto>(moduleUri, {
    tags,
    topReadRange: range,
    take: 10,
    myCS,
    textContains,
    startDate,
    endDate,
  });
  return data;
};
